import { connect } from "react-redux";
import Dashboard from "./Dashboard";
import {
  getDashboardDataRequest,
  supportCoordinatorsRequest,
} from "../../../../store/actions/ah.actions";
import {
  getDashboardDataLoadingSelector,
  getDashboardDataSelector,
  getSupportCoordinator,
  getSupportCoordinatorLoader,
} from "../../../../store/selector/ah.selector";
import { getSpSetting } from "../../../../store/selector/sp.selector";

const mapDispatchToProps = {
  getDashboardDataRequest,
  supportCoordinatorsRequest,
};

const mapStateToProps = (state) => {
  const getDashboardData = getDashboardDataSelector(state);
  const getDashboardDataLoading = getDashboardDataLoadingSelector(state);
  const supportCoordinatorListLoader = getSupportCoordinatorLoader(state);
  const supportCoordinatorOptions = getSupportCoordinator(state);
  const settings = getSpSetting(state);

  return {
    getDashboardData,
    getDashboardDataLoading,
    supportCoordinatorListLoader,
    supportCoordinatorOptions,
    settings,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
